import { Component, ViewChild, forwardRef, Input } from '@angular/core';
import { Platform, ModalController, NavParams, NavController } from 'ionic-angular';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { ConfigProvider } from '../../providers/config/config';
import { CoMapPage } from '../../pages/co-map/co-map';
import { CallNumber } from '@ionic-native/call-number';
import { LocationsProvider } from '../../providers/locations/locations';
import moment from 'moment';
import { CoMapComponent } from '../co-map/co-map';
import { CoEventsExploreComponent } from '../co-events-explore/co-events-explore';
import { AttendPage } from '../../pages/attend/attend';
import { AppState } from '../../config/state';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { LoginProvider } from '../../providers/login/login';
/**
 * Generated class for the CoLocationComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-location',
  templateUrl: 'co-location.html',
  inputs: ["locationInfo", "inputLocationId"]
})
export class CoLocationComponent {
  todayHours: any = {};
  openToday: boolean = true;
  modal: any;
  locationInfo: any = "";
  currentPosition: any;
  libraryDistance: any = "";
  loadHours = false;
  locationAvailability: boolean;
  locationId: any;
  clientKeyword: string;
  viewType: any;
  couldGetLocation: boolean = true;
  showNavbar: boolean = false;
  @Input("inputLocationId") inputLocationId: any;
  @ViewChild(CoMapComponent) innerMap: CoMapComponent;
  @ViewChild(forwardRef(() => CoEventsExploreComponent)) private eventsList: CoEventsExploreComponent;
  menuSide: string = "left";

  constructor(private launchNavigator: LaunchNavigator, public platform: Platform, public modalCtrl: ModalController, private navParams: NavParams, private callNumber: CallNumber, public locationsProvider: LocationsProvider, public config: ConfigProvider, public navCtrl: NavController, public state: AppState, private sounds : SoundsProvider, private login : LoginProvider) {
    this.viewType = this.state.mode;
    if (this.navParams.data.location) this.locationId = this.navParams.data.location;
    if(this.navParams.data.showNavbar) this.showNavbar = true;
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
  };

  ngOnInit() {
    if (!this.navParams.data.location) {
      this.locationId = this.inputLocationId;
    }
    this.getLocationInfo(this.locationId);
  };

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  getLocationInfo(locationId) {
    this.locationsProvider.getLocation(locationId).then((res) => {
      if (res.phone[3] === " ") {
        let splitNum = res.phone.split(' ');
        let rejoinNum = [];
        rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
        res.phone = rejoinNum.join('');
      } else if (res.phone[3] === '-') {
        let splitNum = res.phone.split('-');
        let rejoinNum = [];
        rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
        res.phone = rejoinNum.join('');
      } else {
        res.phone = res.phone;
      };
      // this.todayHours = res.locationHours[i];  USED as test for closed days, set i to day of week branch is closed
      this.locationInfo = res;
      this.loadHours = true;
      if (this.innerMap !== undefined && this.locationInfo.keyword !== 'virtual') {
        this.innerMap.setCurrentLocation(this.locationInfo);
        this.innerMap.setCurrentLocation;
      }
      this.eventsList.getLocationEvents(this.locationInfo.id);
      this.callDistances();
    });
    const today = moment().format("MM/DD/YYYY");
    this.locationsProvider.getWeekHours(locationId, today).then( (res) => {
      if(res && res.length > 0) {
        this.todayHours = res[moment().day()];
        if(this.todayHours.start === this.todayHours.end) this.openToday = false;
        if(this.todayHours.exceptionReason && this.todayHours.exceptionReason.length > 0) this.todayHours.exceptionReason = decodeURIComponent(this.todayHours.exceptionReason);
      }
    });
  };

  async callDistances() {
    let self = this;
    await this.locationsProvider.getUserLocation().then((res) => {
      if (res.lat === "" && res.lng === "") {
        self.couldGetLocation = false;
      } else {
        self.currentPosition = {
          latitude: res.lat,
          longitude: res.lng
        };
        self.couldGetLocation = true;
        self.getDistance();
      }
    }).catch(err => {});
  };

  email(address: string) {
    this.platform.ready().then(() => {
      open('mailto:' + address);
    });
  };

  async getDistance() {
    var radlat1 = Math.PI * this.currentPosition.latitude / 180;
    var radlat2 = Math.PI * this.locationInfo.locationLatitude / 180;
    var theta = this.currentPosition.longitude - this.locationInfo.locationLongitude;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    this.libraryDistance = dist.toFixed(1);
  }

  openMap(locationAddress: any) {
    this.modal = this.modalCtrl.create(CoMapPage, { data: locationAddress });
    this.modal.present();
  };

  openDirections(locationAddress: any) {
    if (this.state.mode !== 'desktop' && this.platform.is('cordova')) {
      this.launchNavigator.navigate(locationAddress.fullAddress)
        .then(
          success => alert('Launched navigator'),
          error => alert('Error launching navigator: ' + error)
        );
    }
    else {
      window.open("//google.com/maps/dir/?api=1&origin=&destination=" + locationAddress.locationLatitude + "," + locationAddress.locationLongitude, "_system");
    }
  };

  call(number: string) {
    this.callNumber.callNumber(number, true)
      .catch(() => console.log('Error launching dialer'));
  };

  goToBranchEvents(location) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(AttendPage, {filterType: 'location', location: location.id, locationName: location.name, filter: { tracker: true, location: [`${location.id}`] }, eventView: 'week' });
    });
  }
  closeFinder(logout:Boolean){
		if(logout){
			this.logout();
		}else{
		  this.state.nav.popToRoot();
		}
	}
	logout() {
		this.login.logout().then( done =>{
			if( done ){
				this.state.nav.popToRoot();
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/co-location/co-location.ts